var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _vm.loading
        ? _c(
            "b-row",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                attrs: { label: "Loading...", variant: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-card",
        { attrs: { title: "Details" } },
        [
          !_vm.loading
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-between flex-column",
                      attrs: { cols: "12", xl: "6" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-start" },
                        [
                          _c("b-avatar", {
                            attrs: {
                              src: "img/13-small.png",
                              size: "104px",
                              rounded: "",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column ml-1" },
                            [
                              _c("div", { staticClass: "mb-1" }, [
                                _c("h4", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.userData.firstName) +
                                      " " +
                                      _vm._s(_vm.userData.lastName) +
                                      " "
                                  ),
                                ]),
                                _c("span", { staticClass: "card-text" }, [
                                  _vm._v(_vm._s(_vm.userData.email)),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-start" },
                        [
                          _c("h4", { staticClass: "mr-2 mt-1" }, [
                            _vm._v("Deactivate/Activate User"),
                          ]),
                          _c("b-form-checkbox", {
                            staticClass: " mt-1",
                            attrs: {
                              disabled:
                                _vm.sortedRoles.filter(function (x) {
                                  return (
                                    (x.roleName.includes("admin") ||
                                      x.roleName.includes("Admin")) &&
                                    x.enabled
                                  )
                                }).length > 0,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateIsActive(
                                  _vm.userData.id,
                                  _vm.userData.isActive
                                )
                              },
                            },
                            model: {
                              value: _vm.userData.isActive,
                              callback: function ($$v) {
                                _vm.$set(_vm.userData, "isActive", $$v)
                              },
                              expression: "userData.isActive",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.sortedRoles.filter(function (x) {
                        return (
                          (x.roleName.includes("admin") ||
                            x.roleName.includes("Admin")) &&
                          x.enabled
                        )
                      }).length > 0
                        ? _c("p", { staticClass: "text-primary" }, [
                            _vm._v(
                              " Cannot Desactivate/Activate an admin user! "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c("b-col", { attrs: { cols: "12", xl: "6" } }, [
                    _c("table", { staticClass: "mt-2 mt-xl-0 w-100" }, [
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "pb-50" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-75",
                              attrs: { icon: "UserIcon" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Username"),
                            ]),
                          ],
                          1
                        ),
                        _c("td", { staticClass: "pb-50" }, [
                          _vm._v(" " + _vm._s(_vm.userData.userName) + " "),
                        ]),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "pb-50" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-75",
                              attrs: { icon: "UserIcon" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("First Name"),
                            ]),
                          ],
                          1
                        ),
                        _c("td", { staticClass: "pb-50" }, [
                          _vm._v(" " + _vm._s(_vm.userData.firstName) + " "),
                        ]),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "pb-50" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-75",
                              attrs: { icon: "UserIcon" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Last Name"),
                            ]),
                          ],
                          1
                        ),
                        _c("td", { staticClass: "pb-50" }, [
                          _vm._v(" " + _vm._s(_vm.userData.lastName) + " "),
                        ]),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "pb-50" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-75",
                              attrs: { icon: "CheckIcon" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Status"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pb-50 text-capitalize" },
                          [
                            _vm.userData.isActive
                              ? _c(
                                  "b-badge",
                                  { attrs: { variant: "success" } },
                                  [_vm._v(" Active ")]
                                )
                              : _c(
                                  "b-badge",
                                  { attrs: { variant: "danger" } },
                                  [_vm._v(" Inactive ")]
                                ),
                          ],
                          1
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          [
                            _c("feather-icon", {
                              staticClass: "mr-75",
                              attrs: { icon: "PhoneIcon" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Contact"),
                            ]),
                          ],
                          1
                        ),
                        _c("td", [
                          _vm._v(" " + _vm._s(_vm.userData.phoneNumber) + " "),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card",
        { attrs: { title: "Roles" } },
        [
          !_vm.loading
            ? _c("b-row", [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-flush-spacing" }, [
                    _c(
                      "tbody",
                      [
                        _c("tr", [
                          _c("td", { staticClass: "text-nowrap fw-bolder" }, [
                            _vm._v(" Administrator Access "),
                            _c(
                              "span",
                              {
                                attrs: {
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-placement": "top",
                                  title: "Allows a full access to the system",
                                },
                              },
                              [_c("i", { attrs: { "data-feather": "info" } })]
                            ),
                          ]),
                          _c("td", [
                            _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectAllData,
                                    expression: "selectAllData",
                                  },
                                ],
                                staticClass: "form-check-input",
                                attrs: { type: "checkbox", id: "selectAll" },
                                domProps: {
                                  checked: Array.isArray(_vm.selectAllData)
                                    ? _vm._i(_vm.selectAllData, null) > -1
                                    : _vm.selectAllData,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.selectAllData,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectAllData = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectAllData = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectAllData = $$c
                                      }
                                    },
                                    function ($event) {
                                      return _vm.selectAllFunction(
                                        _vm.selectAllData
                                      )
                                    },
                                  ],
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "selectAll" },
                                },
                                [_vm._v(" Select All ")]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._l(_vm.sortedRoles, function (item) {
                          return _c("tr", { key: item.roleId }, [
                            _c("td", { staticClass: "text-nowrap fw-bolder" }, [
                              _vm._v(_vm._s(item.roleName)),
                            ]),
                            _c("td", [
                              _c("div", { staticClass: "d-flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-check me-3 me-lg-5" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.enabled,
                                          expression: "item.enabled",
                                        },
                                      ],
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: item.roleId,
                                      },
                                      domProps: {
                                        checked: Array.isArray(item.enabled)
                                          ? _vm._i(item.enabled, null) > -1
                                          : item.enabled,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = item.enabled,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  item,
                                                  "enabled",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  item,
                                                  "enabled",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(item, "enabled", $$c)
                                          }
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form-check-label",
                                        attrs: { for: item.enabled },
                                      },
                                      [_vm._v(" Grant ")]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.addRole },
                      },
                      [
                        _vm.loading
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _vm._e(),
                        _vm._v(" Update User Roles "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }